var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#31B48C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9039 24.275C19.2239 23.407 18.1039 21.979 18.1039 19.767C18.1039 16.827 20.3439 14.279 24.9919 14.279C29.6399 14.279 31.8799 16.855 31.8799 19.767C31.8799 21.923 30.7039 23.463 29.1079 24.275C31.1239 25.143 32.3839 26.907 32.3839 29.287C32.3839 33.179 29.1919 35.531 24.9919 35.531C20.8199 35.531 17.6279 33.179 17.6279 29.287C17.6279 26.879 18.8879 25.115 20.9039 24.275ZM24.9919 23.127C26.7839 23.127 28.0719 22.007 28.0719 20.327C28.0719 18.479 26.8679 17.443 24.9919 17.443C23.1719 17.443 21.9399 18.451 21.9399 20.355C21.9399 22.035 23.2279 23.127 24.9919 23.127ZM24.9919 25.983C22.9479 25.983 21.4079 27.047 21.4079 29.119C21.4079 30.939 22.7519 32.283 24.9919 32.283C27.2319 32.283 28.5479 30.911 28.5479 29.119C28.5479 27.103 27.0919 25.983 24.9919 25.983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8);
export default __webpack_public_path__ + "static/media/8.e12f96fb566bda46c32c054794c513a4.svg";
export { ForwardRef as ReactComponent };